module.exports = __webpack_public_path__ + "img/copy.9f666141.svg";